<template>
  <div>
    <div
      v-for="(buyer, idx) in buyers"
      :key="idx"
      outlined
      class="mb-4"
    >
      <v-row align="start">
        <v-col class="pt-1">
          <template
            v-if="buyer.roles"
          >
            <b>{{
              buyer.roles?.map(role => {
                const roles = {
                  ORGANIZATION: 'Yritys',
                  ORGANIZATION_SIGNER: 'Yrityksen edustaja',
                  SIGNER: 'Ostaja',
                }

                return roles[role];
              }).join(', ')
            }}</b>
            <br>
          </template>

          <template v-if="!buyer.roles?.includes('ORGANIZATION')">
            <participant-detail
              title="Etunimi"
              :value="buyer.person?.firstName"
            />

            <participant-detail
              title="Sukunimi"
              :value="buyer.person?.lastName"
            />

            <participant-detail
              title="Henkilötunnus"
              :value="buyer.person?.socialSecurityNumber"
            />

            <participant-detail
              title="Sähköposti"
              :value="buyer.person?.email"
            />

            <participant-detail
              v-if="buyer.roles?.some(role => role === 'ORGANIZATION_SIGNER')"
              title="Edustaa yrityksiä"
              :value="buyer.businessIds?.map(
              businessId => getCompanyName(businessId)).join(', ')"
            />
          </template>

          <template v-else>
            <participant-detail
              title="Yrityksen nimi"
              :value="buyer.organization.name"
            />

            <participant-detail
              title="VAT-numero"
              :value="buyer.organization.businessId"
            />
          </template>

          <template v-if="buyer?.transferTax">
            Varainsiirtoveron määrä:
            <b>{{ buyer.transferTax.amountInCents / 100 | currency }}</b>
            <br>
          </template>

          <template v-if="buyer?.bankBusinessId">
            Pankki: <b>
              {{ getBankName(buyer.bankBusinessId) }}
            </b>
          </template>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'participant-detail': () => import('@/components/DIAS/DIASParticipantDetail.vue'),
  },
  props: {
    buyers: {
      type: Array,
      default: () => [],
    },
    banks: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getBankName(businessId) {
      const bank = this.banks.find(b => b.businessId === businessId);

      if (bank) {
        return `${bank.name} (${bank.groupName})`;
      }

      return businessId;
    },

    getCompanyName(businessId) {
      const company = this.buyers.find(e => e.organization?.businessId === businessId);

      return company?.organization?.name || '';
    },
  },
};
</script>
